import { render, staticRenderFns } from "./integral-dh-d.vue?vue&type=template&id=4770404b&scoped=true&"
import script from "./integral-dh-d.vue?vue&type=script&lang=js&"
export * from "./integral-dh-d.vue?vue&type=script&lang=js&"
import style0 from "./integral-dh-d.vue?vue&type=style&index=0&id=4770404b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4770404b",
  null
  
)

export default component.exports